import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=d10bf87c"
import script from "./TabItem.ts?vue&type=script&lang=ts&external"
export * from "./TabItem.ts?vue&type=script&lang=ts&external"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=d10bf87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports